import { Person } from '../assessment-app/data/person';

export function resolvePersonOption(
  person: Person | null | undefined,
  personOptions: Array<{ value: Person; label: string }>
): Person | null {
  if (!person) return null;
  return personOptions.find(o =>
    o.value.firstName === person.firstName &&
    o.value.surname === person.surname &&
    o.value.dob === person.dob
  )?.value ?? person;
}